import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function RedNatura2000Layer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="PS.ProtectedSite"
      format="image/png"
      version="1.3.0"
      transparent
      url="https://wms.mapama.gob.es/sig/Biodiversidad/RedNatura/wms.aspx"
      opacity={opacity}
    />
  )
}

export default RedNatura2000Layer
